module.exports = __webpack_public_path__ + "img/class.dede12ac.svg";